// import { lang } from './filters'
import { lang } from '@public/utils/filters'
import { RULES as reles, VALIDATION as validation } from '@public/utils/validators'
console.log('validators validators validators', reles, validation)
// 初始化规则
export const RULES = {
  ...reles,
  ...{
    waybillRule: { validator: waybillRule, trigger: ['blur', 'change'] }, // 运单规格
    int1: { validator: int1, trigger: ['blur', 'change'] },
    chargeRate: { validator: chargeRate, trigger: ['blur', 'change'] },
    int2: { validator: int2, trigger: ['blur', 'change'] },
    int2and100: { validator: int2and100, trigger: ['blur', 'change'] },
    int2and0: { validator: int2and0, trigger: ['blur', 'change'] },
    int2Fload1: { validator: int2Fload1, trigger: ['blur', 'change'] },
    int3Fload1: { validator: int3Fload1, trigger: ['blur', 'change'] },
    int3Fload2and0: { validator: int3Fload2and0, trigger: ['blur', 'change'] },
    int4Fload2and0: { validator: int4Fload2and0, trigger: ['blur', 'change'] },
    int5Fload2and0: { validator: int5Fload2and0, trigger: ['blur', 'change'] },
    intTo9999: { validator: intTo9999, trigger: ['blur'] }, // 0.01 - 9999.99的数字
    oneMinuteTime: { validator: oneMinuteTime, trigger: ['blur'] }, // 60
    oneHourTime: { validator: oneHourTime, trigger: ['blur'] }, // 3600
    minute1ToHour1: { validator: minute1ToHour1, trigger: ['blur'] }, // 60-3600
    organizationCodeValidator: { validator: organizationCodeValidator, trigger: ['blur', 'change'] },
    idCard: { validator: idCard, trigger: ['blur'] }, // 身份证号码
    phoneNumber: { validator: phoneNumber, trigger: ['blur', 'change'] }, // 11位手机号
    intFloatAnd00: { validator: intFloatAnd00, trigger: ['blur', 'change'] }, // 整数或者2位小数
    num1_30: { validator: num1_30, trigger: ['blur'] }, // 1-30的数字
    max100Num: { validator: max100Num, trigger: ['blur', 'change'] }, // 数字0-100
  }
}
export const VALIDATION = {
  ...validation,
  ...{
    'waybillRule': {
      'value': /^[JU]T\d{13}$/,
      'label': lang('请输入正确运单号')
    },
    'oneMinuteTime': {
      'value': /^(60|([1-5][0-9])|[1-9])$/,
      'label': lang('数字:1-60')
    },
    'oneHourTime': {
      'value': /^((3600)|(3[0-5][0-9]{0,2})|([1-2][0-9]{0,3})|([1-9][0-9]{0,2}))$/,
      'label': lang('数字:1-3600')
    },
    'minute1ToHour1': {
      'value': /^(([6-9]\d)|([1-9]\d{2})|([1-2]\d{3})|(3[0-5]\d{2})|3600)$/,
      'label': lang('数字:60-3600')
    },
    'int1': {
      'value': /^[1-9]$/,
      'label': lang('最大数值为1位整数')
    },
    'chargeRate': {
      'value': /^[0-9]{1,2}$/,
      'label': lang('数字:0-99')
    },
    'int2': {
      'value': /^[1-9]\d?$/,
      'label': lang('最大数值为2位整数')
    },
    'int2and100': {
      'value': /^(([1-9]\d?)|100)$/,
      'label': lang('数字:1-100')
    },
    'int2and0': {
      'value': /^[0-9]{1,2}$/,
      'label': lang('数字:0-99')
    },
    'int2Fload1': {
      'value': /^0\.[1-9]$|^[1-9]\d{0,1}(\.\d)?$/,
      'label': lang('最大数值为2位整数+1位小数')
    },
    'int3Fload1': {
      'value': /^0\.[1-9]$|^[1-9]\d{0,2}(\.\d)?$/,
      'label': lang('最大数值为3位整数+1位小数')
    },
    'int3Fload2and0': {
      'value': /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,2}\.\d{0,2}$|^[1-9]\d{0,2}$|^0$/,
      'label': lang('最大数值为3位整数+2位小数')
    },
    'int4Fload2and0': {
      'value': /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,3}\.\d{0,2}$|^[1-9]\d{0,3}$|^0$/,
      'label': lang('最大数值为4位整数+2位小数')
    },
    'int5Fload2and0': {
      'value': /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,4}\.\d{0,2}$|^[1-9]\d{0,4}$|^0$/,
      'label': lang('最大数值为5位整数+2位小数')
    },
    'intTo9999': {
      'value': /^([1-9]\d{0,3})([.]\d{1,2})?$|^0[.]([1-9]\d{0,1}|[0-9][1-9])$/,
      'label': lang('请输入0.01-9999.99的数字')
    },
    'organizationCodeValidator': {
      'value': /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
      'label': lang('统一社会信用代码格式不正确')
    },
    'idCard': {
      'value': /(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)/i,
      'label': lang('15或18位身份证号码')
    },
    'phoneNumber': {
      'value': /(^1[3|4|5|6|7|8|9]\d{9}$)/,
      'label': lang('请输入正确的手机号')
    },
    'intFloatAnd00': {
      'value': /^\d+(.\d\d?)?$/,
      'label': lang('整数或1位小数或2位小数')
    },
    'num1_30': {
      'value': /^([12][0-9]|30|[1-9])$/,
      'label': lang('时间设置范围:1-30')
    },
    'max100Num': {
      'value': /^(([0-9]\d|[0-9]\d)\.[0-9]|0\.[1-9]|(([1-9]\d?)|100|0))$/,
      'label': lang('请输入0-100的数字')
    },
  }
}

// 1-30的数字
export function num1_30(rule, value, callback) {
  if (!VALIDATION.num1_30.value.test(value)) {
    callback(new Error(VALIDATION.num1_30.label))
  } else {
    callback()
  }
}

// 单号规则
export function waybillRule(rule, value, callback) {
  if (!VALIDATION.waybillRule.value.test(value)) {
    callback(new Error(VALIDATION.waybillRule.label))
  } else {
    callback()
  }
}

// 60以内数字
export function oneMinuteTime(rule, value, callback) {
  if (!VALIDATION.oneMinuteTime.value.test(value) && value) {
    callback(new Error(VALIDATION.oneMinuteTime.label))
  } else {
    callback()
  }
}
// 3600以内数字
export function oneHourTime(rule, value, callback) {
  if (!VALIDATION.oneHourTime.value.test(value) && value) {
    callback(new Error(VALIDATION.oneHourTime.label))
  } else {
    callback()
  }
}
// 60-3600以内数字
export function minute1ToHour1(rule, value, callback) {
  if (!VALIDATION.minute1ToHour1.value.test(value) && value) {
    callback(new Error(VALIDATION.minute1ToHour1.label))
  } else {
    callback()
  }
}
// 1整数
export function int1(rule, value, callback) {
  if (value && !VALIDATION.int1.value.test(value)) {
    callback(new Error(VALIDATION.int1.label))
  } else {
    callback()
  }
}
// 0-99
export function chargeRate(rule, value, callback) {
  if (value && !VALIDATION.chargeRate.value.test(value)) {
    callback(new Error(VALIDATION.chargeRate.label))
  } else {
    callback()
  }
}
// 2整数
export function int2(rule, value, callback) {
  if (value && !VALIDATION.int2.value.test(value)) {
    callback(new Error(VALIDATION.int2.label))
  } else {
    callback()
  }
}
// 1-100
export function int2and100(rule, value, callback) {
  if (value && !VALIDATION.int2and100.value.test(value)) {
    callback(new Error(VALIDATION.int2and100.label))
  } else {
    callback()
  }
}
// 0-99
export function int2and0(rule, value, callback) {
  if (value && !VALIDATION.int2and0.value.test(value)) {
    callback(new Error(VALIDATION.int2and0.label))
  } else {
    callback()
  }
}

// 2整数1小数
export function int2Fload1(rule, value, callback) {
  if (value && !VALIDATION.int3Fload1.value.test(value)) {
    callback(new Error(VALIDATION.int3Fload1.label))
  } else {
    callback()
  }
}

// 3整数1小数
export function int3Fload1(rule, value, callback) {
  if (value && !VALIDATION.int3Fload1.value.test(value)) {
    callback(new Error(VALIDATION.int3Fload1.label))
  } else {
    callback()
  }
}
// 3整数2小数
export function int3Fload2and0(rule, value, callback) {
  if (value && !VALIDATION.int3Fload2and0.value.test(value)) {
    callback(new Error(VALIDATION.int3Fload2and0.label))
  } else {
    callback()
  }
}
// 4整数2小数
export function int4Fload2and0(rule, value, callback) {
  if (value && !VALIDATION.int4Fload2and0.value.test(value)) {
    callback(new Error(VALIDATION.int4Fload2and0.label))
  } else {
    callback()
  }
}
// 5整数2小数
export function int5Fload2and0(rule, value, callback) {
  if (value && !VALIDATION.int5Fload2and0.value.test(value)) {
    callback(new Error(VALIDATION.int5Fload2and0.label))
  } else {
    callback()
  }
}
// 0.01-9999.99的数字
export function intTo9999(rule, value, callback) {
  if (!VALIDATION.intTo9999.value.test(value) && value) {
    callback(new Error(VALIDATION.intTo9999.label))
  } else {
    callback()
  }
}
// 统一社会信用代码
export function organizationCodeValidator(rule, value, callback) {
  if (value && !VALIDATION.organizationCodeValidator.value.test(value)) {
    callback(new Error(VALIDATION.organizationCodeValidator.label))
  } else {
    callback()
  }
}
// 身份证号码
export function idCard(rule, value, callback) {
  if (value && !VALIDATION.idCard.value.test(value)) {
    callback(new Error(VALIDATION.idCard.label))
  } else {
    callback()
  }
}
// 手机号码
export function phoneNumber(rule, value, callback) {
  if (!VALIDATION.phoneNumber.value.test(value)) {
    callback(new Error(VALIDATION.phoneNumber.label))
  } else {
    callback()
  }
}
// 整数或者2位小数
export function intFloatAnd00(rule, value, callback) {
  if (value && !VALIDATION.intFloatAnd00.value.test(value)) {
    callback(new Error(VALIDATION.intFloatAnd00.label))
  } else {
    callback()
  }
}

// 0-100数字
export function max100Num(rule, value, callback) {
  if (!VALIDATION.max100Num.value.test(value)) {
    callback(new Error(VALIDATION.max100Num.label))
  } else {
    callback()
  }
}
